export const CRASH_GAME = '/crash-game'
export const WALLET = '/wallet'
export const SYSTEM = '/system'
export const PLINKO_GAME = '/plinko-game'
export const LIVE_CHATS = '/live-chats'
